/** Operator vocabulary and controls from taxonomy v1.5's Value types table. */
export const CRM_FILTER_TAXONOMY_OPERATORS = [
  { id: "is", label: "Is", control: "single-select" },
  { id: "is_not", label: "Is not", control: "single-select" },
  { id: "is_any_of", label: "Is any of", control: "multi-select" },
  { id: "has_changed_to", label: "Has changed to", control: "single-select" },
  {
    id: "has_changed_from",
    label: "Has changed from",
    control: "single-select",
  },
  { id: "has_connected", label: "Has connected", control: "single-select" },
  {
    id: "has_disconnected",
    label: "Has disconnected",
    control: "single-select",
  },
  { id: "has_failed", label: "Has failed", control: "single-select" },
  { id: "has_reconnected", label: "Has reconnected", control: "single-select" },
  { id: "has_completed", label: "Has completed", control: "single-select" },
  {
    id: "has_been_delayed",
    label: "Has been delayed",
    control: "single-select",
  },
  {
    id: "has_not_completed_within_x_hours",
    label: "Has not completed within X hours",
    control: "number-and-list",
  },
  { id: "is_complete", label: "Is complete", control: "none" },
  { id: "is_not_complete", label: "Is not complete", control: "none" },
  {
    id: "has_been_updated",
    label: "Has been updated",
    control: "single-select",
  },
  { id: "is_within", label: "Is within", control: "relative-window" },
  { id: "more_than", label: "More than", control: "relative-window" },
  { id: "never", label: "Never", control: "none" },
  { id: "is_not_started", label: "Is not started", control: "single-select" },
  { id: "is_in_progress", label: "Is in progress", control: "single-select" },
  { id: "is_skipped", label: "Is skipped", control: "single-select" },
  {
    id: "is_not_complete_after_x_days",
    label: "Is not complete after X days",
    control: "number-and-list",
  },
  { id: "greater_than", label: "Greater than", control: "number" },
  { id: "less_than", label: "Less than", control: "number" },
  { id: "equals", label: "Equals", control: "number" },
  { id: "has_used", label: "Has used", control: "single-select" },
  { id: "has_not_used", label: "Has not used", control: "single-select" },
  {
    id: "has_used_within_x_days",
    label: "Has used within X days",
    control: "number-and-list",
  },
  {
    id: "has_not_used_in_x_days",
    label: "Has not used in X days",
    control: "number-and-list",
  },
  {
    id: "has_used_more_than_x_times",
    label: "Has used more than X times",
    control: "number-and-list",
  },
  {
    id: "has_not_completed",
    label: "Has not completed",
    control: "single-select",
  },
  {
    id: "has_completed_after_x_days",
    label: "Has completed after X days",
    control: "number-and-list",
  },
  { id: "is_at_or_below", label: "Is at or below", control: "number" },
  { id: "is_at_or_above", label: "Is at or above", control: "number" },
  { id: "has_added", label: "Has added", control: "single-select" },
  { id: "has_edited", label: "Has edited", control: "single-select" },
  { id: "has_deleted", label: "Has deleted", control: "single-select" },
  { id: "is_missing", label: "Is missing", control: "none" },
  {
    id: "has_changed_by_more_than_x_percent",
    label: "Has changed by more than X%",
    control: "number-and-list",
  },
  { id: "has_happened", label: "Has happened", control: "none" },
  { id: "has_not_happened", label: "Has not happened", control: "none" },
  { id: "is_below", label: "Is below", control: "number" },
  { id: "is_above", label: "Is above", control: "number" },
  { id: "has_dropped_below", label: "Has dropped below", control: "number" },
  { id: "has_risen_above", label: "Has risen above", control: "number" },
  {
    id: "has_changed_by_x",
    label: "Has changed by X",
    control: "number-and-list",
  },
  { id: "has_turned_positive", label: "Has turned positive", control: "none" },
  { id: "has_turned_negative", label: "Has turned negative", control: "none" },
  {
    id: "has_changed_by_x_percent",
    label: "Has changed by X%",
    control: "number-and-list",
  },
  { id: "has_generated", label: "Has generated", control: "single-select" },
  {
    id: "has_not_generated",
    label: "Has not generated",
    control: "single-select",
  },
  { id: "has_shared", label: "Has shared", control: "single-select" },
  { id: "has_downloaded", label: "Has downloaded", control: "single-select" },
  {
    id: "has_not_generated_in_x_months",
    label: "Has not generated in X months",
    control: "number-and-list",
  },
  { id: "has_created", label: "Has created", control: "single-select" },
  { id: "has_updated", label: "Has updated", control: "single-select" },
  { id: "has_hit", label: "Has hit", control: "single-select" },
  { id: "has_missed", label: "Has missed", control: "single-select" },
  { id: "is_at_risk", label: "Is at risk", control: "none" },
  { id: "has_logged_in", label: "Has logged in", control: "single-select" },
  {
    id: "has_not_logged_in_for_x_days",
    label: "Has not logged in for X days",
    control: "number-and-list",
  },
  {
    id: "has_logged_in_for_the_first_time",
    label: "Has logged in for the first time",
    control: "single-select",
  },
  {
    id: "has_returned_after_x_days",
    label: "Has returned after X days",
    control: "number-and-list",
  },
  { id: "has_submitted", label: "Has submitted", control: "single-select" },
  {
    id: "has_not_submitted",
    label: "Has not submitted",
    control: "single-select",
  },
  {
    id: "has_submitted_within_x_days",
    label: "Has submitted within X days",
    control: "number-and-list",
  },
  { id: "has_succeeded", label: "Has succeeded", control: "single-select" },
  { id: "before", label: "Before", control: "date" },
  { id: "after", label: "After", control: "date" },
  { id: "between", label: "Between", control: "date-range" },
  { id: "has_upgraded", label: "Has upgraded", control: "single-select" },
  { id: "has_downgraded", label: "Has downgraded", control: "single-select" },
  {
    id: "is_subscribed_to",
    label: "Is subscribed to",
    control: "single-select",
  },
  {
    id: "is_not_subscribed_to",
    label: "Is not subscribed to",
    control: "single-select",
  },
  { id: "is_current", label: "Is current", control: "none" },
  { id: "has_skipped", label: "Has skipped", control: "single-select" },
] as const;
export type CrmFilterTaxonomyOperator =
  (typeof CRM_FILTER_TAXONOMY_OPERATORS)[number];
export type CrmFilterTaxonomyOperatorId = CrmFilterTaxonomyOperator["id"];
export type CrmFilterTaxonomyOperatorLabel = CrmFilterTaxonomyOperator["label"];
